// extracted by mini-css-extract-plugin
module.exports = {"main":"sk-CardFooter_main__j47mA"};